import { getParams as getExecutiveSummaryParams } from "./executiveSummaryWebsiteApi";
import { journeyExcellenceApiParamsToObject } from "./journeyExcellenceApi";
import { fetchDataV2, newApiFetchV2 } from "./utils";
import { getLatestDataRefreshMetric, getMarketParam } from "./brandPerformanceApi";
import { getVOCParams } from "./vocApi";

export const getMarketDataRefresh = (data: { table: string; brand: string; market: string }) => newApiFetchV2("/available_data/get", data);

export const getMidasFmiLastRefreshDate = () => fetchDataV2("/midas/fmi-run-rate/last-refresh-date", {});
export const getMidasFmiByModelLastRefreshDate = () => fetchDataV2("/midas/fmi-by-model/last-refresh-date", {});
export const getMidasMediaMixLastRefreshDate = () => fetchDataV2("/midas/media-mix/last-refresh-date", {});
export const getMidasMtpCategoryLastRefreshDate = () => fetchDataV2("/midas/mtp-category/last-refresh-date", {});
export const getMidasStrategicDealerSupportLastRefreshDate = () => fetchDataV2("/midas/strategic-dealer-support/last-refresh-date", {});
export const getMidasStrategicCELastRefreshDate = () => fetchDataV2("/midas/strategic-ce/last-refresh-date", {});
export const getMidasFixedLastRefreshDate = () => fetchDataV2("/midas/fixed/last-refresh-date", {});
export const getMidasSpendVsTrafficLastRefreshDate = () => fetchDataV2("/midas/spend-vs-traffic/last-refresh-date", {});
export const getCpoOperationalLastRefreshDate = () => fetchDataV2("/cpo-operational/last-refresh-date", {});
export const getProductPerformanceLastRefreshDate = () => fetchDataV2("/product-performance/last-refresh-date");
export const getJourneyExcellenceLastRefreshDate = (metric: string) => {
  if (metric == "Leads Management System") {
    return newApiFetchV2("/journey-excellence/lms/last-refresh-date", { ...journeyExcellenceApiParamsToObject() });
  }
  return fetchDataV2("/journey-excellence/last-refresh-date");
};
export const getVocLastRefreshDate = () => newApiFetchV2("voc/last-refresh-date", getVOCParams);
export const getUseOwnershipLastRefreshDate = (page: string) => fetchDataV2(`/use-ownership/${page}/last-data-refresh`);
// metric is plain string (not performancePages) to match getBrandPerformanceAvailableDataDateRange's
// own typing - both forward straight into getLatestDataRefreshMetric/the backend's own metric
// mapping, which accept any data-category-style string (e.g. "Volume"/"OaO"/"Image"/"NIM"), not
// just a performancePage name.
export const getBrandPerformanceLastRefreshDate = (metric: string, market: string) =>
  fetchDataV2(
    `/brand-performance/latest-refresh-date?use_cache=true&metric=${getLatestDataRefreshMetric(metric)}&market=${getMarketParam(market)}`
  );
export const getBrandPeformancePurchaseFunnelLastRefreshDate = (market: string) =>
  fetchDataV2(`/brand-performance/purchase-funnel/latest-refresh-date?market=${getMarketParam(market)}`);
export const getBrandPeformanceBrandKPITrendLastRefreshDate = (market: string) =>
  fetchDataV2(`/brand-performance/brand-kpi-trend/latest-refresh-date?market=${getMarketParam(market)}`);
// Real backend (NS-968, cedar-backend's ns-968-eur-epwr-awareness branch) - a dedicated
// per-page endpoint like purchase-funnel/brand-kpi-trend above, not the generic shared one
// Brand Volume falls back to (its own "tech-awareness" metric string matches nothing in the
// backend's own metrics_mapping or underlying data). Unlike those two, there's no companion
// get-available-data-date-range endpoint for this page yet - see docs/brand-performance.md's
// own Tech Awareness section.
export const getBrandPeformanceTechAwarenessLastRefreshDate = (market: string) =>
  fetchDataV2(`/brand-performance/eur-epwr-awareness/latest-refresh-date?market=${getMarketParam(market)}`);
export const getExecutiveSummaryLastRefreshData = () =>
  newApiFetchV2("/executive-summary/dis/last-refresh-date", getExecutiveSummaryParams());
export const getExecutiveSummaryProductPerformanceLastRefreshData = () =>
  fetchDataV2("/executive-summary/product-performance/last-refresh-date", getExecutiveSummaryParams());
export const getDfpLastRefreshDate = () => fetchDataV2("/drivers-for-flash-performance/last-refresh-date");
